var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "min-h-screen flex sm:justify-center pt-6 sm:pt-0 overflow-hidden",
    },
    [
      _c(
        "v-container",
        { staticClass: "flex justify-center align-center upper-third" },
        [
          _c(
            "v-col",
            {
              staticClass: "justify-center",
              attrs: { cols: "12", sm: "10", md: "8", lg: "6" },
            },
            [
              _c("v-img", {
                staticClass: "mx-auto",
                attrs: {
                  src: "/musicologie-wordmark.webp",
                  "max-width": "200",
                },
              }),
              _vm._v(" "),
              _c("lottie-player", {
                staticClass: "mx-auto",
                staticStyle: { width: "300px", height: "300px" },
                attrs: {
                  src: "https://assets7.lottiefiles.com/packages/lf20_pNx6yH.json",
                  background: "transparent",
                  speed: "1",
                  loop: "",
                  autoplay: "",
                },
              }),
              _vm._v(" "),
              _c(
                "v-container",
                { staticStyle: { "max-width": "400px" } },
                [
                  _c("v-card-title", { staticClass: "soli-grey" }, [
                    _vm._v(_vm._s(_vm.title)),
                  ]),
                  _vm._v(" "),
                  _c("v-card-subtitle", { staticClass: "soli-grey flex" }, [
                    _vm._v(
                      _vm._s(_vm.errors.length ? _vm.errors : _vm.description)
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.status === 500 || _vm.status === 503
                    ? _c("v-card-subtitle", { staticClass: "soli-grey" }, [
                        _vm._v(
                          "For internet points and eternal gratitude, please\n                    contact\n                    "
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "soli-blue-text",
                            attrs: {
                              href: `mailto:${
                                _vm.$page.props.staffView ? "kyle" : "feedback"
                              }@musicologie.com`,
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$page.props.staffView ? "kyle" : "feedback"
                              ) + "@musicologie.com"
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }